/** Tone keys for step execution status chips (visual style only — label text is unchanged). */
const TONE_BY_STATUS = {
    success: 'success',
    completed: 'success',
    passed: 'success',
    failed: 'failed',
    running: 'running',
    pending: 'pending',
    skipped: 'skipped',
};

export function resolveStepStatusBadge(status) {
    const key = String(status || 'pending').toLowerCase();
    const tone = TONE_BY_STATUS[key] ?? 'pending';
    return {
        tone,
        spinner: tone === 'running',
    };
}
